import {
  BOM_TEMPLATE_ALL,
  BOM_TEMPLATE_DELETE,
  BOM_TEMPLATE_ERROR,
  BOM_TEMPLATE_GET,
  BOM_TEMPLATE_LOADING,
  BOM_TEMPLATE_POST,
  BOM_TEMPLATE_PUT,
} from '../../actions/types';

const initialState = {
  bomTemplate: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case BOM_TEMPLATE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case BOM_TEMPLATE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case BOM_TEMPLATE_POST:
      return { isLoading: false, isCompleted: true };
    case BOM_TEMPLATE_PUT:
      return { isLoading: false, isCompleted: true };
    case BOM_TEMPLATE_DELETE:
      return { isLoading: false, isCompleted: true };
    case BOM_TEMPLATE_LOADING:
      return { isLoading: true, isCompleted: true };
    case BOM_TEMPLATE_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
